/**
 * コモンクラス
 * @constructor
 */
import HeaderModule from './header';
import BottomNaviModule from './bottom-navi';
import ToTopButtonModule from './to-top-button';

class Common {
  constructor() {
    this.init();
  }
  /**
   * コモン
   */
  init() {
    new HeaderModule();
    new BottomNaviModule();
    new ToTopButtonModule();
  }

}

export default Common;
